import * as React from 'react';
import classNames from 'classnames';
export const ErrorText = ({ error, className }) => (React.createElement("p", { className: classNames('help-block small-txt', className) },
    React.createElement("span", { className: "text-danger" }, error)));
